export class Dashboard {
  "Ingresos_Dolar": number = 0;
  "Ingresos_Dolar_a_Soles": number = 0;
  "Ingresos_Soles": number = 0;
  "Ingresos_Dolar_Otros": number = 0;
  "Ingresos_Dolar_Otros_a_Soles": number = 0;
  "Ingresos_Soles_Otros": number = 0;
  "Cobranza_dolar": number = 0;
  "Cobranza_soles": number = 0;
  "Adelanto_Soles": number = 0;
  "Adelanto_Dolar": number = 0;
  "Adelanto_Dolar_a_Soles": number = 0;
  "Cantidad_Facturas_Soles": number = 0;
  "Cantidad_Facturas_Dolar": number = 0;
  "Numero_Proveedores": number = 0;
  "Numero_Adquirentes": number = 0;
  "VNPP_Soles": number = 0;
  "VNPP_Dolar": number = 0;
  "VNPP_Dolar_a_Soles": number = 0;
  "Tipo_cambio": number = 0;
}
